export default __webpack_public_path__ + "static/national-metric-mobile-edbb180a3cb4535ed43ec629c3b836f2.svg";